export default "__VITE_ASSET__C23j$cn0__"